module.exports = __webpack_public_path__ + "static/media/videoPoster.3073866c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/videoPoster.jpg
// module id = 1635
// module chunks = 0